import React from 'react'
import { InputGroup } from '@blueprintjs/core'

const AppNameInput = props => {
   return (
      <InputGroup
         large
         intent={props.disable ? 'danger' : ''}
         placeholder="Type your application name"
         onChange={props.inputChangeHandler}
         value={props.value}
      />
   )
}

export default AppNameInput
